import { ComponentWrapper, MediaContextProvider } from "./..";
import MobileFooter from "./mobileFooter";
import PcFooter from "./pcFooter";
import "./styles/index.less";
import cx from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var NavigationFooter = function NavigationFooter(props) {
  var innerClassName = props.innerClassName,
      className = props.className,
      style = props.style,
      innerStyle = props.innerStyle;
  return /*#__PURE__*/_jsx("div", {
    className: cx(className, 'dr-footer'),
    style: style,
    children: /*#__PURE__*/_jsxs(MediaContextProvider, {
      children: [/*#__PURE__*/_jsx(ComponentWrapper, {
        children: /*#__PURE__*/_jsx(PcFooter, {
          innerClassName: innerClassName,
          innerStyle: innerStyle
        })
      }), /*#__PURE__*/_jsx(ComponentWrapper, {
        mode: "notPC",
        children: /*#__PURE__*/_jsx(MobileFooter, {})
      })]
    })
  });
};

export default NavigationFooter;